import ActionOnSelectedUsers from './ActionOnSelectedUsers';

export default ActionOnSelectedUsers;
